/**
 * Direct deep-link screen for the Business Metrics saved-view manager.
 */
import { formatInteger } from "./format.js";
import { escapeHtml } from "./dashboard-html.js";
import { fetchJson, fetchSavedViewById, fetchSavedViews } from "./dashboard-lead-factory-fetch.js";
import { leadFactoryBusinessMetricsUrl } from "./dashboard-urls.js";
import { getLeadFactoryMetricsDays, leadFactoryWindowUrl } from "./dashboard-saved-view-state.js";
import { applySavedView } from "./dashboard-saved-view-apply.js";
import { businessMetricsHtml } from "./dashboard-business-metrics.js";
import type { LeadFactoryBusinessMetrics } from "./dashboard-lead-factory-types.js";

const leadFactoryBusinessMetricsScope = "business_metrics" as const;

export function directSavedViewManagerId(): string {
  return new URLSearchParams(window.location.search).get("lf_saved_view_manager")?.trim() ?? "";
}

export async function renderDirectSavedViewManager(
  mount: HTMLElement,
  viewId: string,
  bindActions: (statusElement: HTMLElement) => void
): Promise<void> {
  const readback = await fetchSavedViewById(viewId);
  if (readback.view.scope !== leadFactoryBusinessMetricsScope) {
    throw new Error("Direct saved-view manager currently supports Business Metrics views.");
  }
  applySavedView(readback.view);
  const metricsDays = getLeadFactoryMetricsDays();
  const [businessMetrics, businessMetricsSavedViews] = await Promise.all([
    fetchJson<LeadFactoryBusinessMetrics>(leadFactoryWindowUrl(leadFactoryBusinessMetricsUrl, metricsDays)),
    fetchSavedViews(leadFactoryBusinessMetricsScope)
  ]);
  mount.innerHTML = `
    <main class="dashboard-shell saved-view-manager-direct" data-saved-view-manager-direct>
      <section class="panel">
        <div class="panel-heading">
          <div>
            <h1>Saved View Manager</h1>
            <p class="subtle">${escapeHtml(readback.view.name)} · ${formatInteger(metricsDays)} day Business Metrics view</p>
          </div>
          <a class="button secondary" href="/">Dashboard</a>
        </div>
        ${businessMetricsHtml(businessMetrics, businessMetricsSavedViews.views)}
      </section>
      <aside id="county-detail" class="detail-drawer" aria-live="polite"></aside>
      <p id="action-status" class="action-status" role="status" aria-live="polite">Saved-view manager loaded.</p>
    </main>
  `;
  const statusElement = document.querySelector<HTMLElement>("#action-status");
  if (!statusElement) throw new Error("Missing dashboard element #action-status");
  bindActions(statusElement);
}
